import { Card, RichTextContent } from '@etg/wings';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const CabinUpgradeContentInfoCard = ({
  drawerAdditionalContentText
}) => {
  if (!drawerAdditionalContentText) {
    return null;
  }
  return /*#__PURE__*/_jsx(Card, {
    "data-testid": `${CABIN_UPGRADE.name}-drawer-additional-content-card`,
    children: /*#__PURE__*/_jsx(RichTextContent, {
      children: drawerAdditionalContentText
    })
  });
};
export default CabinUpgradeContentInfoCard;
//# sourceMappingURL=CabinUpgradeContentInfoCard.js.map